export const SERVER =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3001'
    : 'https://sequence-server.ember.zone';

export const SOCKET_SERVER =
  process.env.NODE_ENV === 'development'
    ? 'ws://localhost:3001'
    : 'wss://sequence-server.ember.zone';
